export default __webpack_public_path__ + "static/media/Petideal Creamy Chicken & Shrimp.156ac672.png";